import { render, staticRenderFns } from "./CriarAviso.vue?vue&type=template&id=a209777a"
import script from "./CriarAviso.vue?vue&type=script&lang=ts"
export * from "./CriarAviso.vue?vue&type=script&lang=ts"
import style0 from "./CriarAviso.vue?vue&type=style&index=0&id=a209777a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports